// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"b58169d4","2429":"0a09d294","5464":"0f203fb3","6427":"97b00de0"}[chunkId] + ".chunk.css";
};